import { render } from "./BranchList.vue?vue&type=template&id=a92b8dd6&scoped=true"
import script from "./BranchList.vue?vue&type=script&lang=js"
export * from "./BranchList.vue?vue&type=script&lang=js"

import "./BranchList.vue?vue&type=style&index=0&id=a92b8dd6&scoped=true&lang=css"
import "./BranchList.vue?vue&type=style&index=1&id=a92b8dd6&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a92b8dd6"]])

export default __exports__